import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSuitcaseWork: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="suitcase-work,workspace"><path fillRule="evenodd" clipRule="evenodd" d="M10.75 3.5C9.50736 3.5 8.5 4.50736 8.5 5.75V6H15.5V5.75C15.5 4.50736 14.4926 3.5 13.25 3.5H10.75ZM17 6V5.75C17 3.67893 15.3211 2 13.25 2H10.75C8.67893 2 7 3.67893 7 5.75V6H5.75C3.67893 6 2 7.67893 2 9.75V17.25C2 19.3211 3.67893 21 5.75 21H18.25C20.3211 21 22 19.3211 22 17.25V9.75C22 7.67893 20.3211 6 18.25 6H17Z" fill="currentColor"/></CentralIconBase>;
};

export default IconSuitcaseWork;
